import request from '../utils/request'
import qs from 'qs'
import { getTeamCode } from '@/utils/auth'
import { commonConfig } from '../utils/config'
const { apiHetaoDomain } = commonConfig

export async function getOrderList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/order/list?${qs.stringify(params)}`)
}

export async function getOrgList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/teams/forms`, {
    type: 'POST',
    params
  })
}

export async function getOrgSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/teams/forms/sum`, {
    type: 'POST',
    params
  })
}

export async function getOrgDownload(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/teams/forms/download`, {
    type: 'POST',
    params
  })
}

export async function getChannelLists (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/channels/forms`, {
    type: 'POST',
    params
  })
}

export async function getChannelSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/channels/forms/sum`, {
    type: 'POST',
    params
  })
}

export async function getChannelDownload(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/channels/forms/download`, {
    type: 'POST',
    params
  })
}

export async function getChannelAccLists (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/channels/acc`, {
    type: 'POST',
    params
  })
}

export async function getChannelAccSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/channels/acc/sum`, {
    type: 'POST',
    params
  })
}

export async function getChannelAccDownload(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/channels/acc/download`, {
    type: 'POST',
    params
  })
}

export async function getChannelData (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teamChannel`, params)
}

export async function getStarOrder (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/order`, params)
}

export async function getOrderAcc (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/orderAcc?${qs.stringify(params)}`)
}

export async function getCourseList () {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/course/team/list?teamCode=${getTeamCode()}`)
}

export async function getChannelList (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/channel/list?teamCode=${teamCode}`)
}

// 获取公益课学期
export async function getTermList () {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/term/list`)
}

// 获取体验课学期
export async function getTermListNew (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/terms?${qs.stringify(params)}`)
}

export async function getOrgChart (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/team/table`, params)
}

export async function getChannelChart (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teamChannel/table`, params)
}
